import { render, staticRenderFns } from "./AssistMaterial.vue?vue&type=template&id=a0e34c6c&scoped=true&lang=pug&"
import script from "./AssistMaterial.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterial.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterial.vue?vue&type=style&index=0&id=a0e34c6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e34c6c",
  null
  
)

export default component.exports